import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Breadcrumbs";
import usePageMeta from "@/hooks/use-page-meta";
import { LEGAL_PAGES, BRAND } from "@/constants/content";

// Renders /privacy-policy, /terms-and-conditions, /refund-policy, /cancellation-policy, /medical-disclaimer
export default function LegalPage() {
  const { slug } = useParams();
  const page = Object.values(LEGAL_PAGES).find((p) => p.slug === slug);

  usePageMeta({
    title: page ? `${page.title} — KinFlex Home Healthcare` : "Legal — KinFlex",
    description: page?.intro || "",
    canonical: page ? `https://${BRAND.domain}/${page.slug}` : undefined,
  });

  if (!page) return <Navigate to="/" replace />;

  return (
    <Layout>
      <section className="pt-28 pb-6 md:pt-36 md:pb-12 bg-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-60 pointer-events-none" />
        <div className="container-page relative max-w-4xl">
          <Breadcrumbs items={[{ label: page.title }]} />
          <div className="mt-5 eyebrow">Legal</div>
          <h1 className="mt-2 font-display font-bold text-slate-900 text-4xl md:text-5xl tracking-tight leading-tight">{page.title}</h1>
          <p className="mt-4 text-slate-600">{page.intro}</p>
          <div className="mt-3 text-xs text-slate-400">Last updated: {new Date(page.updated).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container-page max-w-3xl">
          <div className="space-y-8">
            {page.sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-display font-bold text-slate-900 text-2xl">{s.h}</h2>
                <p className="mt-2 text-slate-700 leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
